@if(activeEvents.length > 0){

<div class="popup-overlay" (click)="closePopup()">

  <div class="popup-content" (click)="$event.stopPropagation()">

    <button class="close-btn" (click)="closePopup()">
      ✕
    </button>

    <div class="images-container">

      @for(event of activeEvents; track event.image){

        <img
          [src]="event.image"
          [alt]="event.alt"
          class="popup-image"
        />

      }

    </div>

  </div>

</div>

}